<template>
  <div class="contai_h">
    <!-- 这是头部信息 -->
    <div class="contai">
      <i class="el-icon-s-home">
        <router-link to="/">首页</router-link>
        <span class="head_text">>修改滚动文字 </span>
      </i>
      <div class="haed_cont">
        <span>今天是：{{ deta }}</span>
      </div>
    </div>

    <!-- 内容操作区 -->
    <div class="cont_co">
      <div class="cont_text">
        <div class="cont_coo">
          <h3>当前滚动文字：</h3>
        </div>
        <div class="cont_cot">
          <h3>{{ items.infotext }}</h3>
          <!-- 111 -->
        </div>
      </div>
      <!-- 输入框 -->
      <div class="cont_inp">
        <h3>修改滚动文字：</h3>
        <el-input
          v-model="input"
          placeholder="请输入要修改的文字"
          class="conte"
        ></el-input>
        <el-button type="success" @click="qtj">确定修改</el-button>
      </div>
    </div>

    <!-- <button @click="ces">测试</button> -->
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "scrolling",
  data() {
    return {
      deta: "",
      text: "",
      ACCESS_TOKEN: "",
      items: "",
      input: "",
    };
  },

  methods: {
    qtj() {
      console.log(this.items._id)
      //修改数据
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            `db.collection("info_text").doc("${this.items._id}").update({data:{infotext: "${this.input}"}})`,
        })
        .then(res => {
          console.log(res)
          this.$notify({
            title: "修改成功",
            message: "滚动文字已修改成功，刷新页面即可同步数据",
            type: "success",
          });
        });
    },
    //测试
    // ces() {
    //   this.axios
    //     .get("http://127.0.0.1:19196/CloseDevice&t=" + Math.random())
    //     .then((re) => {
    //       console.log(re);
    //     });
    // },
  },
  created(){
      //获取到this.ACCESS_TOKEN
     this.getTokens()

     //获取当前登录的用户数据
    this.getUserToken()
  },

  mounted() {
    this.deta = dayjs().format("YYYY-MM-DD ddd");
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN");

    setTimeout(()=>{
        //请求数据
    this.axios
      .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query: 'db.collection("info_text").where({}).get()',
      })
      .then((aa) => {
        aa.data.data.forEach((element, index, array) => {
          array[index] = JSON.parse(element);
        });
        this.items = aa.data.data[0];
      });
    },800)

  
  },
};
</script>
<style scoped>
.contai {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
}
.contai i {
  font-size: 25px;
  margin: 13px 40px;
}
.head_text {
  font-size: 20px;
  margin: 2px 6px;
}
.router-link-active {
  text-decoration: none;
  font-size: 20px;
  margin-left: 10px;
}
.haed_cont {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
}
.haed_cont {
  font-size: 20px;
}
.cont_co {
  width: 100%;
  height: 400px;
  background-color: #ffffff;
  margin: 10px auto;
}
.cont_coo {
  margin: 0 10px;
}

.cont_text {
  display: flex;
  flex-direction: row;
}
/* .cont_cot {
  width: 85%;
  height: 40px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
} */
.cont_inp {
  margin: 20px 10px;
}
.conte {
  width: 40%;
}
</style>
